import axios from '../axiosInstance';

export default class {
  constructor(options) {
    // this.core = options.core
    this.URL = `${options.baseUrl}/projects`;
  }

  /**
   * Create new project.
   * @param {Project} project object representing a project
   * @returns {Object} unserialized project with mongo id and owner
   *     _id: {
   *      $oid: <hash_id>
   *    },
   *    owner: <ref_id>,
   *    project_type: String,
   *    name: String
   *    [....]
   */
  async create(project) {
    try {
      const Model = Object.getPrototypeOf(project).constructor;
      const results = await axios.post(`${this.URL}/`, project);
      return new Model(results.data);
    } catch (e) {
      throw new Error('projectsService:createProject: ' + e.message);
    }
  }

  /**
   * Retrive all projects or retrieve based on params
   * @param {Object} Model class model of expected project
   * @param {Object} [params] optional key,value pairs of query params
   * @returns {Array} array of projects
   */
  async get(Model, params = {}) {
    try {
      const type = { project_type: Model.PROJECT_TYPE() };

      let config = {};
      config['params'] = params ? Object.assign({}, params, type) : type;

      const results = await axios.get(`${this.URL}/`, config);
      return results.data.map((d) => new Model(d));
    } catch (e) {
      return new Error('projectsService:get: ' + e.message);
    }
  }

  /**
   * Retrive a specific project by id.
   * @param {Object} Model class model of expected project
   * @param {String} id hash id of project
   * @returns {Object} unserialized project with mongo id and owner
   *     _id: {
   *      $oid: <hash_id>
   *    },
   *    owner: <ref_id>,
   *    project_type: String,
   *    name: String
   *    [....]
   */
  async getByID(Model, id) {
    try {
      const results = await axios.get(`${this.URL}/${id}`);
      return new Model(results.data);
    } catch (e) {
      // moved from a throw to a return because it is a common practice to request access but be denied
      return new Error('projectsService:getByID: ' + e.message);
    }
  }

  /**
   * Update project.
   * @param {Project} project object representing a project
   * @returns {Object} unserialized project with mongo id and owner
   *     _id: {
   *      $oid: <hash_id>
   *    },
   *    owner: <ref_id>,
   *    project_type: String,
   *    name: String
   *    [....]
   */
  async update(project) {
    try {
      const Model = Object.getPrototypeOf(project).constructor;
      const results = await axios.put(`${this.URL}/${project.id}`, project);
      return new Model(results.data);
    } catch (e) {
      throw new Error('projectsService:updateProject: ' + e.message);
    }
  }

  /**
   * Delete a project
   * @param {String} id hash id of project to delete
   * @returns {String} "Data successfully deleted" on success
   */
  async delete(id) {
    try {
      const results = await axios.delete(`${this.URL}/${id}`);
      return results.data;
    } catch (e) {
      throw new Error('projectsService:delete: ' + e.message);
    }
  }
}
